var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Grey/Date") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G03",
    transform: "translate(-24.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Grey/Date",
    transform: "translate(24.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#748898",
    strokeWidth: 2,
    x: 1,
    y: 2.41176471,
    width: 22,
    height: 20.5882353,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#748898",
    x: 5.64705882,
    y: 9.17647059,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#748898",
    x: 10.5882353,
    y: 9.17647059,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#748898",
    x: 15.5294118,
    y: 9.17647059,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#748898",
    x: 5.64705882,
    y: 14.8235294,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#748898",
    x: 10.5882353,
    y: 14.8235294,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#748898",
    x: 15.5294118,
    y: 14.8235294,
    width: 2.82352941,
    height: 2.82352941,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.41176471,
    y1: 0.274509804,
    x2: 7.41176471,
    y2: 4.66666667,
    id: "Line",
    stroke: "#748898",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.2941176,
    y1: 0.274509804,
    x2: 17.2941176,
    y2: 4.66666667,
    id: "Line-Copy",
    stroke: "#748898",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondary);
export default __webpack_public_path__ + "static/media/Secondary.c879abd584e2a277164cff99bdcbc591.svg";
export { ForwardRef as ReactComponent };